import { call, put, takeLeading } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';
import { resolvePromiseAction, rejectPromiseAction } from 'redux-saga-promise-actions';
import * as actions from 'store/actions/rebooking';
import Endpoints from 'endpoints';
import GipsyApiGds from 'apis/GipsyGDS';
import {
  TicketCreditInformationOld,
  RebookingTypeId,
  GetRebookingPassengerBuyType,
  CheckoutResponse,
} from 'store/types';
import { request } from './api';

function* getCreditsBookingInformationOld(action: ActionType<typeof actions.getCreditBookingInformation.request>) {
  const { bookingId, tickets, type } = action.payload;
  try {
    const response: { data: TicketCreditInformationOld } = yield GipsyApiGds.get(
      Endpoints.getCreditInformations(bookingId, tickets, type),
    );
    yield put(actions.getCreditBookingInformation.success(response.data));
    yield call(resolvePromiseAction, action, response.data);
  } catch (error) {
    yield put(actions.getCreditBookingInformation.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

function* createRebooking(action: ActionType<typeof actions.createRebooking.request>) {
  const { tickets } = action.payload;
  try {
    const response: { data: RebookingTypeId } = yield request(
      {
        method: 'post',
        url: Endpoints.createRebooking,
        data: {
          ticketIds: tickets,
        },
      },
      true,
    );
    yield put(actions.createRebooking.success(response.data));
    yield call(resolvePromiseAction, action, response.data);
  } catch (error) {
    yield put(actions.createRebooking.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

function* getRebookingBuyerPassenger(action: ActionType<typeof actions.getRebookingBuyerPassenger.request>) {
  const { RebookingId } = action.payload;

  try {
    const authData: any = localStorage.getItem('authAgencyData');
    const { token } = JSON.parse(authData);
    const response: { data: GetRebookingPassengerBuyType } = yield request(
      {
        method: 'get',
        url: Endpoints.getRebookingBuyerPassenger,
        params: {
          RebookingId,
        },
        headers: {
          Authorization: `bearer ${token}`,
        },
      },
      true,
    );
    yield put(actions.getRebookingBuyerPassenger.success(response.data));
    yield call(resolvePromiseAction, action, response.data);
  } catch (error) {
    yield put(actions.getRebookingBuyerPassenger.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

function* makePaymentRebooking(action: ActionType<typeof actions.makePaymentRebooking.request>) {
  try {
    const authData: any = localStorage.getItem('authAgencyData');
    const { token } = JSON.parse(authData);
    const response: { data: CheckoutResponse } = yield request(
      {
        method: 'post',
        url: Endpoints.paymentRebooking,
        data: {
          ...action.payload,
        },
        headers: {
          Authorization: `bearer ${token}`,
        },
      },
      true,
    );
    yield put(actions.makePaymentRebooking.success(response.data));
    yield call(resolvePromiseAction, action, response.data);
  } catch (error) {
    yield put(actions.makePaymentRebooking.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

export const watchRebooking = [
  takeLeading(actions.getCreditBookingInformation.request, getCreditsBookingInformationOld),
  takeLeading(actions.createRebooking.request, createRebooking),
  takeLeading(actions.getRebookingBuyerPassenger.request, getRebookingBuyerPassenger),
  takeLeading(actions.makePaymentRebooking.request, makePaymentRebooking),
];
